import React, { useMemo, useState } from 'react';
import {
  MobileGameHolder,
  MobileGameStructure,
  MobileGameWr,
  DefaultQueryParams,
  GameControllers,
  iframeService,
  parseQuery,
  RightSideHolder,
  useTranslation,
  useUserInfoStore,
  MobileStructureMiddle,
  OverlayFooter,
  tableBetHistoryStore,
  useSoundWatcher,
} from '@pascal/pascal-core';
import { GameControllerTypes } from '@pascal/pascal-core/table-line/t_types/enums/GameControllerTypes';
import { observer } from 'mobx-react-lite';
import { useLocation, useNavigate } from 'react-router-dom';
import { GAME_CONTROLLER_TYPES } from '@pascal/pascal-core/shared/core/enums/gameControllerTypes';
import { applicationStore } from '@pascal/pascal-core/shared/core/store';
import { HelpPopup } from '../components/helpPopup';
import { BetHistoryWr } from './betHistory';
import { SettingsContainer } from './settingsContainer';
import AdditionalResultWr from './payoutsAndResultsContainer/additionResultWr';
import { MobileGameMain } from '../game';
import { GAME_CONTROLLER_TYPES_YET } from '../enums/constants';
import { LiveBets } from '../components/liveBets';

const gameControllerComponents = {
  [GAME_CONTROLLER_TYPES_YET.BETS]: <LiveBets />,
  [GameControllerTypes.Help]: <HelpPopup />,
  [GameControllerTypes.History]: <BetHistoryWr />,
  [GameControllerTypes.Settings]: <SettingsContainer />,
};

const isDemo = false;
const isTurbo = true;

export const MobileGame = observer(() => {
  const t = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();
  const { [DefaultQueryParams.UserId]: userId } = parseQuery(search);
  const [gameControllerType, setGameControllerType] = useState('');
  const { selectedHistoryRow, setSelectedHistoryRow } = tableBetHistoryStore;
  const { currencyCode } = useUserInfoStore();
  const { isTestPlatform } = applicationStore;
  // const { roomName } = useLobbyStore();

  useSoundWatcher();

  const GameControllerComponent = useMemo(() => {
    const component = gameControllerComponents[gameControllerType];
    if (component) {
      return component;
    }
    return null;
  }, [gameControllerType]);

  const navigationItems = useMemo(() => {
    const items = [
      {
        icon: 'icon-home1',
        name: t('HOME'),
        onClick: () => iframeService.exitGame(),
      },
      {
        icon: 'icon-lobby',
        name: t('LOBBY'),
        onClick: () => navigate(`/${search}`),
      },
      {
        icon: 'icon-bets',
        name: t('BETS'),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES_YET.BETS),
      },
      {
        icon: 'icon-history',
        name: t('HISTORY'),
        isDisabled: !userId || isDemo,
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.HISTORY),
      },
      {
        icon: 'icon-settings',
        name: t('SETTINGS'),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.SETTINGS),
      },
      {
        icon: 'icon-help',
        name: t('RULES'),
        onClick: () => setGameControllerType(GAME_CONTROLLER_TYPES.HELP),
        isPayTable: true,
      },
    ];
    if (isTurbo) {
      items.splice(1, 1);
      return items;
    }
    if (isTestPlatform) {
      items.splice(3, 1);
      return items;
    }
    return items;
  }, [isTestPlatform, navigate, search, t, userId]);

  // useEffect(() => {
  //   const el = document.createElement('span');
  //   const parent = document.querySelector('.m-user-count-holder');
  //   el.classList.add('m-user-count-txt');
  //   el.innerText = usersCount || '';
  //   parent.prepend(el);
  // }, [usersCount]);

  return (
    <MobileGameWr>
      <MobileGameStructure>
        <MobileStructureMiddle haveNotification translationValues={{}}>
          <MobileGameHolder>
            <MobileGameMain />
          </MobileGameHolder>
          <GameControllers
            currencyCode={currencyCode}
            controllerType={gameControllerType}
            setGameControllerType={() => setGameControllerType(null)}
            selectedHistoryRow={selectedHistoryRow}
            setSelectedHistoryRow={setSelectedHistoryRow}
            gameControllerComponent={GameControllerComponent}
            hasScrollToBottom={gameControllerType === GAME_CONTROLLER_TYPES.RESULTS}
            additionalContent={
              gameControllerType === GAME_CONTROLLER_TYPES.RESULTS ? (
                <OverlayFooter title={t('LAST_CARDS')}>
                  <AdditionalResultWr />
                </OverlayFooter>
              ) : null
            }
          />
          <RightSideHolder navigationItems={navigationItems} />
        </MobileStructureMiddle>
      </MobileGameStructure>
    </MobileGameWr>
  );
});
